import { createTheme } from "@mui/material";
import componentsOverride from "./overrides";
import palette from "./palette";
import shadows, { customShadows } from "./shadows";
import shape from "./shape";
import typography from "./typography";

const themeOptions = {
    palette,
    typography,
    shape,
    shadows,
    customShadows,
};

const theme = createTheme(themeOptions);
theme.components = componentsOverride(theme);
export default theme;
